const mapEl = document.getElementById('branchMap');
const branchDetailsEl = document.getElementById('branchDetails');
let map = null;
let openInfowindow = null;
let center = null;
let branch = window.branch;

const toggleStickyContacts = function () {
  const stickyContacts = document.querySelector('.coop-c-branchhero__sticky-drawer__links');
  const button = document.querySelector('.coop-c-branchhero__sticky-drawer__button');
  const icon = document.querySelector('.coop-c-branchhero__sticky-drawer__button svg');
  if (stickyContacts.classList.contains('coop-c-branchhero__sticky-drawer__links--open')) {
    stickyContacts.classList.remove('coop-c-branchhero__sticky-drawer__links--open');
    icon.style.transform = 'rotate(0deg)';
    button.setAttribute('data-linktext', 'Close');
  }
  else {
    stickyContacts.classList.add('coop-c-branchhero__sticky-drawer__links--open');
    icon.style.transform = 'rotate(180deg)';
    button.setAttribute('data-linktext', 'Open');
  }
}


const debounce = function (callback) {
  let timer;
  return function (event) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(callback, 200, event);
  };
}

const locationMarker = function (location, i) {
  if (!location) {
    return;
  }
  return new google.maps.Marker({
    position: {
      lat: location.position.lat,
      lng: location.position.lng
    },
    icon: {
      url: window.mapMarkerImage,
      size: new google.maps.Size(54, 67),
      scaledSize: new google.maps.Size(54, 67)
    },
    title: location.name,
    map: map
  });
}

const addLocationMarker = function (locations) {
  if (!locations || locations.length < 1) {
    return;
  }

  const location = branch;
  const marker = locationMarker(location, 0);
  center = marker.getPosition();
}

const elOuterWidth = function (el) {
  let width = el.offsetWidth;
  const style = getComputedStyle(el);
  width += parseInt(style.marginLeft) + parseInt(style.marginRight);
  return width;
}

const mapOffset = function () {
  return window.outerWidth >= 768 ? elOuterWidth(branchDetailsEl) / 8 : 0;
}

const offsetCenter = function () {
  const scale = Math.pow(2, map.getZoom());
  const worldCoordinateCenter = map.getProjection().fromLatLngToPoint(center);
  const pixelOffset = new google.maps.Point((mapOffset() / scale) || 0, 0 || 0);
  const worldCoordinateNewCenter = new google.maps.Point(
    worldCoordinateCenter.x - pixelOffset.x,
    worldCoordinateCenter.y + pixelOffset.y
  );
  const newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
  map.setCenter(newCenter);
}

const buildMap = function () {
  map = new google.maps.Map(mapEl, {
    center: branch.position,
    disableDefaultUI: true,
    zoom: 15,
    zoomControl: true,
    scaleControl: true
  });

  if (branch) {
    addLocationMarker(branch);
  }

  google.maps.event.addListenerOnce(
    map,
    "projection_changed", function () {
      offsetCenter()
      window.addEventListener(
        "resize",
        debounce(function () {
          offsetCenter()
        })
      );
    }
  );
}

buildMap();

const isHeroOutOfView = function () {
  const hero = document.querySelector('.coop-c-branchhero');
  const heroRect = hero.getBoundingClientRect();
  return heroRect.bottom < 0;
}

const handleSticky = function () {
  const banner = document.querySelector('.coop-c-branchhero__sticky-banner');
  const drawer = document.querySelector('.coop-c-branchhero__sticky-drawer');
  if (isHeroOutOfView()) {
    banner.classList.add('coop-c-branchhero__sticky-banner--show');
    drawer.classList.add('coop-c-branchhero__sticky-drawer--show');
  } else {
    banner.classList.remove('coop-c-branchhero__sticky-banner--show');
    drawer.classList.remove('coop-c-branchhero__sticky-drawer--show');
  }
}

document.addEventListener('scroll', function () {
  handleSticky();
});

document.addEventListener("DOMContentLoaded", function() {
  handleSticky();
});